import { Stack, IconButton } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { brandSocials } from '../trackingTemplateUtils';

const ICONS = { instagram: InstagramIcon, facebook: FacebookIcon, twitter: TwitterIcon, linkedin: LinkedInIcon, whatsapp: WhatsAppIcon };

// Single source for the brand social-link row (replaces the SOCIAL_ICONS map + row markup that was
// duplicated in Modern and Minimal). Renders only the links present on the brand.
export default function SocialRow({ brand, color = '#9A9A95', hoverColor, size = 20, spacing = 1 }) {
    const socials = brandSocials(brand);
    if (!socials.length) return null;
    return (
        <Stack direction="row" spacing={spacing}>
            {socials.map((s) => {
                const Icon = ICONS[s.key];
                return (
                    <IconButton key={s.key} component="a" href={s.url} target="_blank" rel="noreferrer" size="small"
                        sx={{ color, transition: 'color .2s', ...(hoverColor ? { '&:hover': { color: hoverColor } } : {}) }}>
                        <Icon sx={{ fontSize: size }} />
                    </IconButton>
                );
            })}
        </Stack>
    );
}
